export var SecurityAdvisorySeverity;
(function (SecurityAdvisorySeverity) {
    SecurityAdvisorySeverity["CRITICAL"] = "CRITICAL";
    SecurityAdvisorySeverity["HIGH"] = "HIGH";
    SecurityAdvisorySeverity["LOW"] = "LOW";
    SecurityAdvisorySeverity["MODERATE"] = "MODERATE";
})(SecurityAdvisorySeverity || (SecurityAdvisorySeverity = {}));
;
export var EntityMwgithubaccesscontrol_PermissionTargetType;
(function (EntityMwgithubaccesscontrol_PermissionTargetType) {
    EntityMwgithubaccesscontrol_PermissionTargetType["GithubOrg"] = "EntityMwgithubaccesscontrol_PermissionTargetType.GithubOrg";
    EntityMwgithubaccesscontrol_PermissionTargetType["GithubRepo"] = "EntityMwgithubaccesscontrol_PermissionTargetType.GithubRepo";
    EntityMwgithubaccesscontrol_PermissionTargetType["GithubSite"] = "EntityMwgithubaccesscontrol_PermissionTargetType.GithubSite";
    EntityMwgithubaccesscontrol_PermissionTargetType["GithubTeam"] = "EntityMwgithubaccesscontrol_PermissionTargetType.GithubTeam";
})(EntityMwgithubaccesscontrol_PermissionTargetType || (EntityMwgithubaccesscontrol_PermissionTargetType = {}));
export var EntityMwgithubaccesscontrol_PrincipalType;
(function (EntityMwgithubaccesscontrol_PrincipalType) {
    EntityMwgithubaccesscontrol_PrincipalType["GithubTeam"] = "EntityMwgithubaccesscontrol_PrincipalType.GithubTeam";
    EntityMwgithubaccesscontrol_PrincipalType["GithubUser"] = "EntityMwgithubaccesscontrol_PrincipalType.GithubUser";
    EntityMwgithubaccesscontrol_PrincipalType["GithubUserExternal"] = "EntityMwgithubaccesscontrol_PrincipalType.GithubUserExternal";
    EntityMwgithubaccesscontrol_PrincipalType["GithubApp"] = "EntityMwgithubaccesscontrol_PrincipalType.GithubApp";
})(EntityMwgithubaccesscontrol_PrincipalType || (EntityMwgithubaccesscontrol_PrincipalType = {}));
export var EntityMwSecrets_Type;
(function (EntityMwSecrets_Type) {
    EntityMwSecrets_Type["SecretTypeNa"] = "SecretTypeNa";
    EntityMwSecrets_Type["SecretTypeOrg"] = "SecretTypeOrg";
    EntityMwSecrets_Type["SecretTypeRepo"] = "SecretTypeRepo";
    EntityMwSecrets_Type["SecretTypeRepoEnv"] = "SecretTypeRepoEnv";
})(EntityMwSecrets_Type || (EntityMwSecrets_Type = {}));
;
